export enum ItineraryEditorType {
    None = "none",
    Standard = "standard",
    Custom = "custom",
    Assisted = "assisted",
}
